"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.string.pad-start");
var _pageConfig = require("@/api/decorate/pageConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "PageConfig",
  filters: {
    formatDate: function formatDate(value) {
      if (!value) return '';
      var date = new Date(value);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  },
  data: function data() {
    return {
      loading: false,
      searchForm: {
        name: ""
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      // 抽屉相关数据
      drawerVisible: false,
      drawerTitle: "",
      submitLoading: false,
      isEdit: false,
      editId: null,
      formData: {
        pageName: "",
        pageUrl: "",
        appid: ""
      },
      formRules: {
        pageName: [{
          required: true,
          message: "请输入页面名称",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        pageUrl: [{
          required: true,
          message: "请输入页面地址",
          trigger: "blur"
        }, {
          min: 1,
          max: 500,
          message: "长度在 1 到 500 个字符",
          trigger: "blur"
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getTableData();
  },
  methods: {
    // 获取表格数据
    getTableData: function () {
      var _getTableData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              params = {
                page: this.pagination.current,
                limit: this.pagination.size,
                pageName: this.searchForm.name
              };
              _context.next = 2;
              return (0, _pageConfig.getPageConfigList)(params);
            case 2:
              response = _context.sent;
              // 根据实际返回的数据结构处理
              if (response) {
                this.tableData = response.records || [];
                this.pagination.total = response.total || 0;
              } else {
                this.tableData = [];
                this.pagination.total = 0;
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error("获取数据失败:", _t);
              this.$message.error("获取数据失败: " + (_t.message || "未知错误"));
              this.tableData = [];
              this.pagination.total = 0;
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getTableData() {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }(),
    // 搜索
    handleSearch: function handleSearch() {
      this.pagination.current = 1;
      this.getTableData();
    },
    // 新建页面配置
    handleCreate: function handleCreate() {
      this.isEdit = false;
      this.editId = null;
      this.drawerTitle = "新增页面";
      this.resetForm();
      this.drawerVisible = true;
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.isEdit = true;
      this.editId = row.id;
      this.drawerTitle = "编辑页面";

      // 调用详情接口获取数据
      this.getPageConfigDetail(row.id);
    },
    // 获取页面配置详情
    getPageConfigDetail: function () {
      var _getPageConfigDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var response, detailData, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.submitLoading = true;
              _context2.prev = 1;
              _context2.next = 2;
              return (0, _pageConfig.getPageConfigDetail)(id);
            case 2:
              response = _context2.sent;
              // 假设返回的数据结构与列表中的记录结构一致
              detailData = response.data || response;
              this.formData = {
                id: detailData.id,
                pageName: detailData.pageName,
                pageUrl: detailData.pageUrl,
                appid: detailData.appid
              };
              this.drawerVisible = true;
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              this.$message.error("获取详情失败: " + (_t2.message || "未知错误"));
            case 4:
              _context2.prev = 4;
              this.submitLoading = false;
              return _context2.finish(4);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function getPageConfigDetail(_x) {
        return _getPageConfigDetail2.apply(this, arguments);
      }
      return getPageConfigDetail;
    }(),
    // 删除
    handleDelete: function handleDelete(row) {
      var _this = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u9875\u9762\"".concat(row.pageName, "\"\u5417\uFF1F"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        // 调用删除接口
        (0, _pageConfig.deletePageConfig)(row.id).then(function (response) {
          _this.$message.success("删除成功");
          _this.getTableData();
        }).catch(function (error) {
          _this.$message.error("删除失败: " + (error.message || "未知错误"));
        });
      }).catch(function () {
        _this.$message.info("已取消删除");
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.size = val;
      this.pagination.current = 1;
      this.getTableData();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.current = val;
      this.getTableData();
    },
    // 抽屉相关方法
    // 重置表单
    resetForm: function resetForm() {
      var _this2 = this;
      this.formData = {
        pageName: "",
        pageUrl: "",
        appid: ""
      };
      this.$nextTick(function () {
        if (_this2.$refs.drawerForm) {
          _this2.$refs.drawerForm.clearValidate();
        }
      });
    },
    // 关闭抽屉
    handleDrawerClose: function handleDrawerClose() {
      this.drawerVisible = false;
      this.resetForm();
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.drawerForm.validate(function (valid) {
        if (valid) {
          _this3.submitLoading = true;
          var requestPromise;

          // 根据是编辑还是新增调用不同的接口
          if (_this3.isEdit) {
            // 编辑时调用修改接口
            requestPromise = (0, _pageConfig.updatePageConfig)(_this3.formData);
          } else {
            // 新增时调用保存接口
            requestPromise = (0, _pageConfig.savePageConfig)(_this3.formData);
          }

          // 调用接口
          requestPromise.then(function (response) {
            _this3.$message.success(_this3.isEdit ? "编辑成功" : "新增成功");
            _this3.submitLoading = false;
            _this3.drawerVisible = false;
            _this3.resetForm();
            _this3.getTableData();
          }).catch(function (error) {
            _this3.$message.error((_this3.isEdit ? "编辑失败: " : "新增失败: ") + (error.message || "未知错误"));
            _this3.submitLoading = false;
          });
        } else {
          _this3.$message.error("请完善表单信息");
          return false;
        }
      });
    }
  }
};